/**
  * 数据字典模块接口列表
  */

 import base from '../base'; // 导入接口域名列表
 import axios from '../../request/http'; // 导入http中创建的axios实例
 
 const dictionaryApi = {
     getDataDictionary: `${base.qa}/DataItem/GetDataItemTreeList`,
     GetDataItemDetailTreeList: `${base.qa}/DataItem/GetDataItemDetailTreeListByItemId`,
     SaveDataItemDetail: `${base.qa}/DataItem/SaveDataItemDetail`,
     DelDataItemDetail: `${base.qa}/DataItem/DelDataItemDetail`,
     GetDataItemDetailInfo: `${base.qa}/DataItem/GetDataItemDetailInfo`,
     SaveDataItem: `${base.qa}/DataItem/SaveDataItem`,
     GetDataItemInfo: `${base.qa}/DataItem/GetDataItemInfo`,
     DelDataItem: `${base.qa}/DataItem/DelDataItem`,
     GetDataItemListByCode: `${base.qa}/DataItem/GetDataItemListByCode`,
     GetDataItemDetailTreeListByItemCode: `${base.qa}/DataItem/GetDataItemDetailTreeListByItemCode`,
 }
 
 const dictionary = {
     getDataDictionary () {
         return axios.get(dictionaryApi.getDataDictionary)
     },
     GetDataItemDetailTreeList (params) {
         return axios.get(dictionaryApi.GetDataItemDetailTreeList, { params: { itemid: params } })
     },
     SaveDataItemDetail (params) {
         return axios.post(dictionaryApi.SaveDataItemDetail, params)
     },
     DelDataItemDetail (params) {
         return axios.post(dictionaryApi.DelDataItemDetail, params)
     },
     GetDataItemDetailInfo (params) {
         return axios.get(dictionaryApi.GetDataItemDetailInfo, { params: { itemdetailid: params } })
     },
     SaveDataItem (params) {
         return axios.post(dictionaryApi.SaveDataItem, params)
     },
     GetDataItemInfo (params) {
         return axios.get(dictionaryApi.GetDataItemInfo, { params: { itemid: params } })
     },
     GetDataItemListByCode (params) {
         return axios.get(dictionaryApi.GetDataItemListByCode, { params })
     },
     GetDataItemDetailTreeListByItemCode (params) {
         return axios.get(dictionaryApi.GetDataItemDetailTreeListByItemCode, { params: { itemcode: params } })
     },
     DelDataItem (params) {
         return axios.post(dictionaryApi.DelDataItem, params)
     },
 }
 
 
 export default dictionary;